// src/styles/sharedStyles.js
import styled from 'styled-components';

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
  max-width: 550px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* 👈 stack fields vertically on mobile */
  }
`;

export const FullWidth = styled.div`
  grid-column: 1 / 3;

  @media (max-width: 768px) {
    grid-column: 1 / 2; /* Optional — resets to 1 column when stacked */
  }
`;

